import api from '../configurations/axios';
import CreditWinnerResult from '../responses/CreditWinnerResult';

export interface CreditWinnerEntry {
    creditAmount: number;
    numberOfUsers: number;
}

class CreditWinnersService {
    async addCreditWinners(competitionId: number, entries: CreditWinnerEntry[]): Promise<CreditWinnerResult[]> {
        const response = await api.post<CreditWinnerResult[]>(`/api/winners/credit/${competitionId}`, { entries });
        return response.data;
    }
}

export default new CreditWinnersService();
